const navigationCopy = {
  'navigation.link.missions': 'Missions',
  'navigation.link.codes': 'Codes',
  'navigation.link.qr_code': 'QR Codes',
  'navigation.link.content': 'Content',
  'navigation.link.create_org': 'Create',
}

export default navigationCopy
